const AbstractPayyoRequestRecord = require('./AbstractPayyoRequestRecord');
const { removeNullValues } = require('@/functions/functions');

class PayyoDeviceRegistrationRequestRecord extends AbstractPayyoRequestRecord {
    constructor(registrationData) {
        super(
            'POST',
            'devices'
        );

        // @TODO flesh out the validation in PROP-1490 Remove location from device registration
        if (!registrationData) {
            throw new Error('registrationData object is required');
        }

        this.data = removeNullValues(registrationData, true);
    }
}

module.exports = PayyoDeviceRegistrationRequestRecord;
